import "@/App.css";
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { ServicesComplete } from "./components/ServicesComplete";
import { Process } from "./components/Process";
import { Advantages } from "./components/Advantages";
import { FAQ } from "./components/FAQ";
import { QuoteRequest } from "./components/QuoteRequest";
import { SellDevice } from "./components/SellDevice";
import { Gallery } from "./components/Gallery";
import { Testimonials } from "./components/Testimonials";
import { TestimonialsNew } from "./components/TestimonialsNew";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { FloatingWidgets } from "./components/FloatingWidgets";
import { MultilingualForm } from "./components/MultilingualForm";
import { AdminQuotes } from "./components/AdminQuotes";
import BotManagementLive from "./components/BotManagementLive";
import { Login } from "./components/Login";
import { ForgotPassword } from "./components/ForgotPassword";
import { ResetPassword } from "./components/ResetPassword";
import { MentionsLegales } from "./components/MentionsLegales";
import { PolitiqueConfidentialite } from "./components/PolitiqueConfidentialite";
import { TermesConditions } from "./components/TermesConditions";
import { PricingGuarantee } from "./components/PricingGuarantee";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { useState } from "react";
import ChatBot from "./components/ChatBot";
import QuickActionsBar from "./components/QuickActionsBar";
import { VirtualAssistant } from "./components/VirtualAssistant";
import { ThemeSwitcher } from "./components/ThemeSwitcher";
// Pages Piliers SEO
import IphonePage from "./components/pages/IphonePage";
import SamsungPage from "./components/pages/SamsungPage";
import OrdinateurPage from "./components/pages/OrdinateurPage";
import BatteriePage from "./components/pages/BatteriePage";
import TabletPage from "./components/pages/TabletPage";
import MicroSoudurePage from "./components/pages/MicroSoudurePage";
import { OurSpecialties } from "./components/OurSpecialties";

function HomePage() {
  return (
    <>
      <Navbar />
      <Hero />
      <QuickActionsBar />
      <ServicesComplete />
      <OurSpecialties />
      <PricingGuarantee />
      <Process />
      <Advantages />
      <QuoteRequest />
      <Gallery />
      <FAQ />
      <SellDevice />
      <TestimonialsNew />
      <Contact />
      <Footer />
      <FloatingWidgets />
      <MultilingualForm />
      <ChatBot />
      <VirtualAssistant />
    </>
  );
}

function ProtectedAdminRoute() {
  const { isAuthenticated, login, loading } = useAuth();
  const [showForgotPassword, setShowForgotPassword] = useState(false);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-xl">Chargement...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    if (showForgotPassword) {
      return <ForgotPassword onBackToLogin={() => setShowForgotPassword(false)} />;
    }
    return <Login onLogin={login} onForgotPassword={() => setShowForgotPassword(true)} />;
  }

  return <AdminQuotes />;
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          {/* <SEOHead /> Temporairement désactivé pour debug */}
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/mentions-legales" element={<MentionsLegales />} />
            <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />
            <Route path="/termes-conditions" element={<TermesConditions />} />
            {/* Pages Piliers SEO */}
            <Route path="/reparation-iphone-villeurbanne" element={<IphonePage />} />
            <Route path="/reparation-samsung-villeurbanne" element={<SamsungPage />} />
            <Route path="/reparation-ordinateur-villeurbanne" element={<OrdinateurPage />} />
            <Route path="/reparation-batterie-villeurbanne" element={<BatteriePage />} />
            <Route path="/reparation-tablette-villeurbanne" element={<TabletPage />} />
            <Route path="/micro-soudure-villeurbanne" element={<MicroSoudurePage />} />
            <Route path="/admin/login" element={<Login />} />
            <Route path="/admin" element={<ProtectedAdminRoute />} />
            <Route path="/admin/devis" element={<ProtectedAdminRoute />} />
            <Route path="/admin/bot-live" element={<ProtectedAdminRoute><BotManagementLive /></ProtectedAdminRoute>} />
            <Route path="/admin/reset-password" element={<ResetPassword />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster />
          <ThemeSwitcher />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
